import {IGetAIReviewJobResultResponse} from '../../../../api/types/aiReview.type';

export const getJobResultMockResponse: IGetAIReviewJobResultResponse = {
  jobId: 1,
  totalDocCount: 9,
  excludedCount: 2,
  submittedCount: 7,
  completedCount: 3,
  erroredCount: 4,
  relevantDocCount: 2,
  nonRelevantDocCount: 1,
  lastUpdated: '4/9/2026 12:23:27 PM',
};
